import { createProxies } from "./proxies";

interface BufferManagerExportsMethods {
  CreateBuffer: (id: number, len: number) => number;
  CreateResizableBuffer: (arg: number) => number;
  ExtendResizableBuffer: (arg: number) => number;
}

export interface BufferManagerExports {
  Buffers: BufferManagerExportsMethods;
}

export const {
  setup,
  createBuffer,
  createResizableBuffer,
  extendResizableBuffer,
} = createProxies<BufferManagerExportsMethods>([
  "CreateBuffer",
  "CreateResizableBuffer",
  "ExtendResizableBuffer",
]);
